/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import EditView from '../../view/pages/hotel/EditView'
import HotelStore from '../../store/hotel/HotelStore'
import HotelAction from '../../action/hotel'

class HotelEditContainer extends Component {
  static getStores() {
    return [HotelStore]
  }

  static calculateState(prevState, props) {
    return {
      hotel: HotelStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const id = this.state.match.params.id
    if (id) HotelAction.fetchOne(id)
  }

  render() {
    return EditView(this.state)
  }
}

export default withRouter(Container.create(HotelEditContainer, { withProps: true }))
